(() => {
  const isSearchTemplate = document?.body?.matches('.search');

  if (!isSearchTemplate) {
    return;
  }

  const searchNavigationButtons = document.querySelectorAll(
    '.search-results__navigation .wp-block-buttons .wp-block-button a',
  );

  if (searchNavigationButtons?.length === 0) {
    return;
  }

  searchNavigationButtons.forEach((searchNavigationButton) => {
    searchNavigationButton.setAttribute(
      'aria-label',
      `Scroll to ${searchNavigationButton.textContent}`,
    );
    searchNavigationButton.setAttribute('title', searchNavigationButton.textContent);

    let correspondingTotal = document.querySelector(
      `${searchNavigationButton?.hash} .wp-block-query-total`,
    );

    if (!correspondingTotal) {
      return;
    }

    correspondingTotal = parseInt(correspondingTotal?.textContent?.trim()?.split(' ')[0]);

    if (!Number.isInteger(correspondingTotal)) {
      return;
    }

    searchNavigationButton.textContent += ` (${correspondingTotal})`;
  });
})();
